import React, { useEffect, useMemo, useState } from "react";
import Footer from "../Header/Footer";
import Header from "../Header/Header";
import Config from "../Header/Config";
import { useNavigate } from "react-router-dom";
import {
  FaEdit,
  FaEye,
  FaRegEye,
  FaShoppingCart,
  FaTrash,
  FaTrashAlt,
  FaFileExcel,
  FaFilePdf,
} from "react-icons/fa";
import { exportFilteredToExcel } from "../../utils/excelExport";
import { exportFilteredToPDF } from "../../utils/pdfExport";
const ITEMS_PER_PAGE = 500; // Number of items to display per page
export default function Purchase_table() {
  const [purchaseItems, setPurchaseItems] = useState([]);
  const [activeTab, setActiveTab] = useState("Unsold"); // "All", "Unsold" or "Sold"
  const [isLoading, setIsLoading] = useState(true);
  const apiUrl = Config.apiUrl;
  //................................................................[ fetch all data ]...........................................................
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${apiUrl}/get_all_purchaseItems`);

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const result = await response.json();

        if (result.status === 'success' && result.data) {
          setPurchaseItems(result.data.reverse());
        } else {
          setPurchaseItems([]);
        }
        setIsLoading(false);

        console.log("Purchase Items Data:", result);
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false);
        setPurchaseItems([]);
      }
    };

    fetchData();
  }, [apiUrl]);

  //..............................................................

  const navigate = useNavigate();

  const handleView = async (id) => {
    const invoice = id;
    navigate(`/purchase_invoice?invoice_no=${invoice}`);
  };

  //................................................................

  const handleUpdate = async (id, event) => {
    const invoice = id;
    navigate(`/purchase_update?invoice_no=${invoice}`);
  };

  //..................................................................

  // Delete Record from database
  const handleDelete = (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this record?"
    );

    if (confirmDelete) {
      fetch(`${apiUrl}/delete_purchaseDetails/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        // Set the new status value to 1 (deleted)
      })
        .then((response) => response.json())
        .then(() => {
          alert(id);
          // Reload the page to reflect the updated data (with the deleted row removed)
          window.location.reload();
        })
        .catch((error) => {
          console.error("Error updating status:", error);
        });
    }
  };

  //............................[ search box]..............................................
  const [searchQuery, setSearchQuery] = useState(""); // State variable for the search query

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  // Filter data based on sold/unsold status
  const filteredByStatus = useMemo(() => {
    if (activeTab === "All") {
      // Show all records
      return purchaseItems;
    }
    return purchaseItems.filter((row) => {
      const rowStatus = row.status || "";
      return rowStatus.toLowerCase() === activeTab.toLowerCase();
    });
  }, [purchaseItems, activeTab]);

  const filteredTableData = filteredByStatus.filter(
    (row) =>
      (row.model_name &&
        row.model_name.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (row.purchase_price &&
        row.purchase_price.toString().includes(searchQuery.toString())) ||
      (row.invoice_no &&
        row.invoice_no.toString().includes(searchQuery.toString())) ||
      (row.imei &&
        row.imei.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (row.purchase_type &&
        row.purchase_type.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (row.sale_price &&
        row.sale_price.toString().includes(searchQuery.toString())) ||
      (row.color &&
        row.color.toLowerCase().includes(searchQuery.toLowerCase()))
  );

  // Calculate sum of Purchase Price for Unsold tab
  const purchasePriceSum = useMemo(() => {
    if (activeTab === "Unsold") {
      return filteredTableData.reduce((sum, row) => {
        const price = parseFloat(row.purchase_price) || 0;
        return sum + price;
      }, 0);
    }
    return 0;
  }, [filteredTableData, activeTab]);


  //..................................[ Pagination ].........................................

  const [currentPage, setCurrentPage] = useState(1);

  // Calculate the total number of pages based on the data and items per page
  const totalPages = Math.ceil(filteredTableData.length / ITEMS_PER_PAGE);

  // Calculate the index range for the items to be displayed on the current page
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = Math.min(
    startIndex + ITEMS_PER_PAGE,
    filteredTableData.length
  );

  // Function to handle pagination button clicks
  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  // Excel Export Handler
  const handleExportToExcel = () => {
    const columns = [
      { key: 'model_name', label: 'Model Name' },
      { key: 'color', label: 'Color' },
      { key: 'imei', label: 'IMEI' },
      { key: 'purchase_type', label: 'Purchase Type' },
      { key: 'purchase_price', label: 'Purchase Price' },
      { key: 'sale_price', label: 'Sale Price' },
    ];
    const fileName = `PurchaseList_${activeTab}`;
    exportFilteredToExcel(filteredTableData, columns, fileName);
  };

  // PDF Export Handler
  const handleExportToPDF = () => {
    const columns = [
      { key: 'model_name', label: 'Model Name' },
      { key: 'color', label: 'Color' },
      { key: 'imei', label: 'IMEI' },
      { key: 'purchase_type', label: 'Purchase Type' },
      { key: 'purchase_price', label: 'Purchase Price' },
      { key: 'sale_price', label: 'Sale Price' },
    ];
    const fileName = `PurchaseList_${activeTab}`;
    exportFilteredToPDF(filteredTableData, columns, fileName);
  };

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <h4 className="fw-bold py-3 mb-4">Purchase List</h4>

                <hr className="my-5" />
                
                {/* Tabs for All, Unsold and Sold */}
                <div className="mb-4">
                  <ul className="nav nav-tabs nav-tabs-custom" role="tablist" style={{ borderBottom: "2px solid #e0e0e0" }}>
                    <li className="nav-item" role="presentation" style={{ marginRight: "5px" }}>
                      <button
                        className={`nav-link ${activeTab === "Unsold" ? "active" : ""}`}
                        type="button"
                        onClick={() => {
                          setActiveTab("Unsold");
                          setCurrentPage(1);
                        }}
                        style={{
                          cursor: "pointer",
                          backgroundColor: activeTab === "Unsold" ? "#696cff" : "#ffffff",
                          color: activeTab === "Unsold" ? "white" : "#495057",
                          border: activeTab === "Unsold" ? "2px solid #696cff" : "2px solid #dee2e6",
                          borderBottom: activeTab === "Unsold" ? "2px solid #696cff" : "2px solid #dee2e6",
                          padding: "12px 30px",
                          borderRadius: "8px 8px 0 0",
                          fontWeight: activeTab === "Unsold" ? "600" : "500",
                          fontSize: "15px",
                          transition: "all 0.3s ease",
                          marginBottom: "-2px",
                          outline: "none",
                          boxShadow: activeTab === "Unsold" ? "0 -2px 8px rgba(105, 108, 255, 0.2)" : "0 1px 3px rgba(0, 0, 0, 0.1)",
                        }}
                        onMouseEnter={(e) => {
                          if (activeTab !== "Unsold") {
                            e.target.style.backgroundColor = "#f8f9fa";
                            e.target.style.color = "#696cff";
                            e.target.style.borderColor = "#696cff";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (activeTab !== "Unsold") {
                            e.target.style.backgroundColor = "#ffffff";
                            e.target.style.color = "#495057";
                            e.target.style.borderColor = "#dee2e6";
                          }
                        }}
                      >
                        Unsold
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className={`nav-link ${activeTab === "Sold" ? "active" : ""}`}
                        type="button"
                        onClick={() => {
                          setActiveTab("Sold");
                          setCurrentPage(1);
                        }}
                        style={{
                          cursor: "pointer",
                          backgroundColor: activeTab === "Sold" ? "#696cff" : "#ffffff",
                          color: activeTab === "Sold" ? "white" : "#495057",
                          border: activeTab === "Sold" ? "2px solid #696cff" : "2px solid #dee2e6",
                          borderBottom: activeTab === "Sold" ? "2px solid #696cff" : "2px solid #dee2e6",
                          padding: "12px 30px",
                          borderRadius: "8px 8px 0 0",
                          fontWeight: activeTab === "Sold" ? "600" : "500",
                          fontSize: "15px",
                          transition: "all 0.3s ease",
                          marginBottom: "-2px",
                          outline: "none",
                          boxShadow: activeTab === "Sold" ? "0 -2px 8px rgba(105, 108, 255, 0.2)" : "0 1px 3px rgba(0, 0, 0, 0.1)",
                        }}
                        onMouseEnter={(e) => {
                          if (activeTab !== "Sold") {
                            e.target.style.backgroundColor = "#f8f9fa";
                            e.target.style.color = "#696cff";
                            e.target.style.borderColor = "#696cff";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (activeTab !== "Sold") {
                            e.target.style.backgroundColor = "#ffffff";
                            e.target.style.color = "#495057";
                            e.target.style.borderColor = "#dee2e6";
                          }
                        }}
                      >
                        Sold
                      </button>
                    </li>
                    <li className="nav-item" role="presentation" style={{ marginRight: "5px" }}>
                      <button
                        className={`nav-link ${activeTab === "All" ? "active" : ""}`}
                        type="button"
                        onClick={() => {
                          setActiveTab("All");
                          setCurrentPage(1);
                        }}
                        style={{
                          cursor: "pointer",
                          backgroundColor: activeTab === "All" ? "#696cff" : "#ffffff",
                          color: activeTab === "All" ? "white" : "#495057",
                          border: activeTab === "All" ? "2px solid #696cff" : "2px solid #dee2e6",
                          borderBottom: activeTab === "All" ? "2px solid #696cff" : "2px solid #dee2e6",
                          padding: "12px 30px",
                          borderRadius: "8px 8px 0 0",
                          fontWeight: activeTab === "All" ? "600" : "500",
                          fontSize: "15px",
                          transition: "all 0.3s ease",
                          marginBottom: "-2px",
                          outline: "none",
                          boxShadow: activeTab === "All" ? "0 -2px 8px rgba(105, 108, 255, 0.2)" : "0 1px 3px rgba(0, 0, 0, 0.1)",
                        }}
                        onMouseEnter={(e) => {
                          if (activeTab !== "All") {
                            e.target.style.backgroundColor = "#f8f9fa";
                            e.target.style.color = "#696cff";
                            e.target.style.borderColor = "#696cff";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (activeTab !== "All") {
                            e.target.style.backgroundColor = "#ffffff";
                            e.target.style.color = "#495057";
                            e.target.style.borderColor = "#dee2e6";
                          }
                        }}
                      >
                        All
                      </button>
                    </li>
                  </ul>
                </div>

                {/* Search Box and Export Button */}
                <div style={{ display: "flex", justifyContent: "end", gap: "10px", alignItems: "center" }}>
                  <div className="mb-3 col-md-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search..."
                      value={searchQuery}
                      onChange={handleSearch}
                    />
                  </div>
                  {/* <div className="mb-3">
                    <button
                      className="btn btn-success"
                      onClick={handleExportToExcel}
                      disabled={!filteredTableData || filteredTableData.length === 0}
                      title="Export to Excel"
                      style={{ display: "flex", alignItems: "center", gap: "5px" }}
                    >
                      <FaFileExcel />
                      Export Excel
                    </button>
                  </div> */}
                  <div className="mb-3">
                    <button
                      className="btn btn-danger"
                      onClick={handleExportToPDF}
                      disabled={!filteredTableData || filteredTableData.length === 0}
                      title="Export to PDF"
                      style={{ display: "flex", alignItems: "center", gap: "5px" }}
                    >
                      <FaFilePdf />
                      Export PDF
                    </button>
                  </div>
                </div>

                <div className="card">
                  <h5 className="card-header">
                    Purchase List
                    {activeTab === "Unsold" && purchasePriceSum > 0 && (
                      <span style={{ 
                        marginLeft: "20px", 
                        fontSize: "16px", 
                        fontWeight: "600",
                        color: "#696cff"
                      }}>
                        Total Purchase Price: ₹{purchasePriceSum.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </span>
                    )}
                  </h5>
                  <div
                    className="table-container"
                    style={{ overflowY: "auto", maxHeight: "600px" }}
                  >
                    {isLoading ? (
                      <div className="d-flex justify-content-center mb-5">
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="sr-only "></span>
                        </div>
                      </div>
                    ) : (
                      <table className="table">
                        <thead
                          style={{
                            position: "sticky",
                            top: 0,
                            zIndex: 1,
                            backgroundColor: "#f5f5f5",
                          }}
                        >
                          <tr className="text-nowrap" style={{ backgroundColor: "yellow", color: "Black" }}>
                            <th>Sr</th>
                            <th>Model Name</th>
                            <th>Color</th>
                            <th>IMEI</th>
                            <th>Purchase Type</th>
                            <th>
                              Purchase Price
                            </th>

                            <th>ACTION</th>
                          </tr>
                        </thead>

                        <tbody>
                          {Array.isArray(filteredTableData) &&
                            filteredTableData.length > 0 ? (
                            filteredTableData
                              .slice(startIndex, endIndex)
                              .map((row, index) => {
                                // Find original index in filteredByStatus (tab-wise data)
                                // Use IMEI as primary key since it's unique
                                let originalIndex = -1;
                                if (row.imei) {
                                  originalIndex = filteredByStatus.findIndex(item => item.imei === row.imei);
                                }
                                // Fallback to ID if IMEI not found
                                if (originalIndex === -1 && row.id) {
                                  originalIndex = filteredByStatus.findIndex(item => item.id === row.id);
                                }
                                // Final fallback to multiple fields
                                if (originalIndex === -1) {
                                  originalIndex = filteredByStatus.findIndex(
                                    item => item.invoice_no === row.invoice_no && 
                                    item.model_name === row.model_name &&
                                    item.color === row.color &&
                                    item.purchase_price === row.purchase_price
                                  );
                                }
                                
                                // Use original position in filteredByStatus + 1
                                const serialNumber = originalIndex !== -1 ? originalIndex + 1 : (startIndex + index + 1);
                                return (
                                <tr key={index} >
                                  <td>{serialNumber}</td>
                                  <td>{row.model_name}</td>
                                  <td>{row.color}</td>
                                  <td style={{ backgroundColor: "rgba(105, 108, 255, 0.16)", color: "black" }}>
                                    <b>{row.imei}</b>
                                  </td>
                                  <td>{row.purchase_type || "-"}</td>
                                  <td style={{ backgroundColor: "#FFCCCB", color: "black" }}>
                                    <b>{row.purchase_price}</b>
                                  </td>

                                  <td>
                                    {row.purchase_type !== "BuyBack" && (
                                      <button
                                      style={{
                                        padding: "0px",
                                        marginLeft: "2px",
                                        marginRight: "2px",
                                        backgroundColor: "transparent", // Set background color to transparent
                                        color: "white", // Set text color to white
                                        border: "1px solid #fff", // Add a border for better visibility
                                      }}
                                        type="submit"
                                        className=""
                                        onClick={() => handleView(row.invoice_no)}
                                      >
                                        <FaEye style={{ color: "green" }} />
                                      </button>
                                    )}
                                    {activeTab === "Unsold" && row.purchase_type !== "BuyBack" && (
                                      <button
                                      style={{
                                        padding: "0px",
                                        marginLeft: "2px",
                                        marginRight: "2px",
                                        backgroundColor: "transparent", // Set background color to transparent
                                        color: "white", // Set text color to white
                                        border: "1px solid #fff", // Add a border for better visibility
                                      }}
                                        type="submit"
                                        className="btn btnn"
                                        onClick={() =>
                                          handleUpdate(row.invoice_no)
                                        }
                                      >
                                        <FaEdit style={{ color: "blue" }} />{" "}
                                        {/* Set icon color to black */}
                                      </button>
                                    )}

                                    {/* <button
                                    style={{
                                      padding: "0px",
                                      marginLeft: "2px",
                                      marginRight: "2px",
                                      backgroundColor: "transparent", // Set background color to transparent
                                      color: "white", // Set text color to white
                                      border: "1px solid #fff", // Add a border for better visibility
                                    }}
                                      type="submit"
                                      className="btn btnn "
                                      onClick={() => handleDelete(row.id)}
                                    >
                                      <FaTrashAlt style={{ color: "red" }} />
                                    </button> */}
                                  </td>
                                </tr>
                                );
                              })
                          ) : (
                            <tr>
                              <td colSpan="7">No data available</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
                {/* Pagination */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    padding: "10px 10px",
                  }}
                >
                  <nav aria-label="Page navigation">
                    <ul className="pagination">
                      {/* Previous arrow button */}
                      <li
                        className={`page-item ${currentPage === 1 ? "disabled" : ""
                          }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                        >
                          {"<"}
                        </button>
                      </li>

                      {/* Page numbers */}
                      {Array.from(
                        { length: totalPages },
                        (_, index) => index + 1
                      ).map(
                        (pageNumber) =>
                          // Render the page number button only if it's within the range of visible pages
                          pageNumber >= currentPage - 2 &&
                          pageNumber <= currentPage + 2 && (
                            <li
                              key={pageNumber}
                              className={`page-item ${pageNumber === currentPage ? "active" : ""
                                }`}
                            >
                              <button
                                className="page-link"
                                onClick={() => handlePageChange(pageNumber)}
                              >
                                {pageNumber}
                              </button>
                            </li>
                          )
                      )}

                      {/* Next arrow button */}
                      <li
                        className={`page-item ${currentPage === totalPages ? "disabled" : ""
                          }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        >
                          {">"}
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>

              <Footer />

              <div className="content-backdrop fade" />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle" />
      </div>
    </>
  );
}
